/**
 * Pure-функции для TopUpModal UX-логики.
 *
 * Вынесены из компонента чтобы быть тестируемыми без React rendering
 * (vitest 2.1.8 без jsdom — компонентные тесты требуют настройки
 * @testing-library/react, что отложено до PR #4).
 *
 * Этап 6 (план §10.4): пресеты 100/200/500 FP (целые баллы; 1 FP = 1 ₽).
 * - Подсвечивать наименьший пресет, который ПОКРЫВАЕТ нужную сумму (>= required).
 * - Если required > max preset — null (UI должен показать "своя сумма" input).
 */

export const DEFAULT_TOPUP_PRESETS_FP = [
  100,
  200,
  500,
] as const;

/**
 * @param requiredFp - сколько нужно (penalty - deposit из InsufficientDepositError).
 * @param presets - отсортированный по возрастанию массив пресетов.
 * @returns пресет >= requiredFp, или null если required > max(presets).
 *
 * Пример:
 *   pickPresetToCover(320, [100, 200, 500]) === 500
 *   pickPresetToCover(50, [100, 200, ...]) === 100
 *   pickPresetToCover(1500, [100, 200, 500]) === null
 */
export function pickPresetToCover(
  requiredFp: number,
  presets: readonly number[],
): number | null {
  if (requiredFp <= 0) {
    // 0 или отрицательное — депозит уже достаточен, не предлагаем пополнение.
    return null;
  }
  for (const p of presets) {
    if (p >= requiredFp) {
      return p;
    }
  }
  return null;
}

/**
 * Сколько не хватает юзеру для вступления. Всегда > 0 если меньше required.
 *
 * Пример: required=500, deposit=320 → 180 (1.80₽).
 */
export function missingFp(requiredFp: number, currentFp: number): number {
  const diff = requiredFp - currentFp;
  return diff > 0 ? diff : 0;
}
